// `grid vault …` subcommand group — #1766. Per-grid secret store (decision
// 023). Item values are write-only: set/rotate read them out-of-band and never
// echo them; list never receives a value from the API.

import { Command } from 'commander';
import { vaultListCommand } from './list.js';
import { vaultSetCommand } from './set.js';
import { vaultRotateCommand } from './rotate.js';

export const vaultCommand = new Command('vault')
  .description('Manage a grid\'s vault items (values are write-only; never printed)')
  .addCommand(vaultSetCommand)
  .addCommand(vaultListCommand)
  .addCommand(vaultRotateCommand);
